import { useMutation } from '@apollo/client';
import { useState } from 'react';
import { UPDATE_ULTRA_PLAN_CHILD_PROFILE } from '../graphql/Mutations';

const useDefaultChildSwitch = ({ userSubscriptionId, onSwitched }) => {
  const [switchingChildId, setSwitchingChildId] = useState(null);
  const [updateChildProfile] = useMutation(UPDATE_ULTRA_PLAN_CHILD_PROFILE, {
    onError() {},
  });

  const switchDefaultChild = async (childProfile) => {
    if (!childProfile?.id || switchingChildId) return false;
    setSwitchingChildId(childProfile?.id);
    try {
      const response = await updateChildProfile({
        variables: {
          where: { id: childProfile?.id, userSubscriptionId },
          data: { isDefault: true },
        },
      });
      if (!response?.data?.updateChildProfile) return false;
      await onSwitched?.();
      return true;
    } finally {
      setSwitchingChildId(null);
    }
  };

  return { switchDefaultChild, switchingChildId };
};

export default useDefaultChildSwitch;
